// Bilingual translations dictionary for Rodríguez Tax Services
export const translations = {
  es: {
    brand: "Rodríguez Tax Services",
    brand_tag: "Impuestos · Contabilidad · Negocios",
    nav: {
      home: "Inicio",
      services: "Servicios",
      about: "Experiencia",
      testimonials: "Testimonios",
      contact: "Contacto",
      cta: "Agenda una consulta",
    },
    lang_toggle: "EN",
    hero: {
      overline: "Servicios profesionales bilingües",
      title: "Tus impuestos, tu negocio,",
      title_accent: "manejados con cuidado.",
      subtitle:
        "Preparación de taxes personales y de negocios, bookkeeping, formación de LLCs y asesoría para expatriados. Atención clara, honesta y bilingüe (ES/EN).",
      cta_primary: "Reserva tu consulta",
      cta_secondary: "Ver servicios",
      stat_label: "Familias y negocios atendidos",
      stat_value: "+1,200",
      founder_byline: "Atendido personalmente por Julio Rodríguez",
      founder_label: "Fundador",
      founder_title: "Asesor Fiscal · Especialista Bilingüe",
    },
    services: {
      overline: "Lo que hacemos",
      title: "Servicios diseñados para tu vida y tu negocio",
      subtitle:
        "Desde una declaración personal sencilla hasta la formación de tu LLC, te acompañamos en cada paso.",
      items: [
        {
          key: "personal",
          name: "Taxes Personales",
          desc: "Maximizamos tu reembolso y aseguramos que todos los créditos a los que tienes derecho estén incluidos.",
          features: ["W-2 y 1099", "Créditos por hijos y EITC", "Estado y federal"],
        },
        {
          key: "business",
          name: "Negocios · Schedule C",
          desc: "Para self-employed, contratistas y dueños de pequeños negocios. Maximizamos deducciones legítimas.",
          features: ["LLC y sole proprietor", "Deducciones de gastos", "Estimados trimestrales"],
        },
        {
          key: "expats",
          name: "Expatriados (Expats)",
          desc: "Si vives fuera de EE.UU. o tienes ingresos internacionales, te ayudamos con FBAR, FEIE y más.",
          features: ["Form 2555 (FEIE)", "FBAR / FinCEN", "Tratados fiscales"],
        },
        {
          key: "bookkeeping",
          name: "Bookkeeping",
          desc: "Mantén tus libros al día todo el año para tomar mejores decisiones y evitar sorpresas.",
          features: ["Conciliación mensual", "Reportes P&L", "QuickBooks / Wave"],
        },
        {
          key: "formation",
          name: "Creación de Negocios",
          desc: "Te ayudamos a constituir tu LLC o Corp, obtener tu EIN y arrancar con el pie derecho.",
          features: ["LLC, S-Corp, C-Corp", "EIN y operating agreement", "Asesoría inicial"],
        },
      ],
      learn_more: "Saber más",
    },
    selector: {
      overline: "¿En qué te podemos ayudar?",
      title: "Cuéntanos tu problema, te damos la solución",
      subtitle:
        "Selecciona la situación que mejor describe lo que necesitas y te mostraremos exactamente qué servicio resuelve tu caso.",
      problems: [
        {
          id: "p1",
          q: "No sé cómo declarar como self-employed o contratista 1099",
          a: "Te ayudamos con Schedule C, deducciones legítimas y pagos estimados para que no tengas sorpresas con el IRS.",
          link_label: "Ver servicio de Schedule C",
          link_to: "/services#business",
        },
        {
          id: "p2",
          q: "Vivo fuera de EE.UU. y no sé si debo declarar impuestos",
          a: "Si eres ciudadano o residente, lo más probable es que sí. Manejamos FEIE, FBAR y todas las formas internacionales.",
          link_label: "Ver servicio de Expats",
          link_to: "/services#expats",
        },
        {
          id: "p3",
          q: "Quiero abrir una LLC pero no sé por dónde empezar",
          a: "Te guiamos en todo: elegir el estado, formar la entidad, obtener el EIN y abrir cuenta bancaria de negocio.",
          link_label: "Crear mi negocio",
          link_to: "/services#formation",
        },
        {
          id: "p4",
          q: "Mis libros están en desorden y necesito ponerme al día",
          a: "Catch-up bookkeeping mensual o trimestral, conciliaciones bancarias y reportes que entiendes.",
          link_label: "Ver bookkeeping",
          link_to: "/services#bookkeeping",
        },
        {
          id: "p5",
          q: "Recibí una carta del IRS y no sé qué hacer",
          a: "Revisamos la notificación contigo, te explicamos qué quieren y te ayudamos a responder correctamente.",
          link_label: "Hablar con nosotros",
          link_to: "/contact",
        },
        {
          id: "p6",
          q: "Quiero un reembolso más alto este año",
          a: "Revisamos tu situación, créditos disponibles y posibles enmiendas de años anteriores.",
          link_label: "Agendar revisión",
          link_to: "/contact",
        },
      ],
    },
    about: {
      overline: "Sobre nosotros",
      title: "Más de una década ayudando a la comunidad",
      caption_label: "Fundador",
      caption_role: "Asesor Fiscal · Rodríguez Tax Services",
      p1: "Rodríguez Tax Services nació para ofrecer a la comunidad hispana y a pequeños empresarios un servicio claro, honesto y bilingüe. Sabemos lo difícil que es navegar el sistema fiscal en otro idioma; por eso simplificamos cada paso.",
      p2: "Trabajamos con familias, freelancers, dueños de negocios y expatriados en todo Estados Unidos. Cada cliente recibe atención personalizada, no un número de fila.",
      stats: [
        { value: "12+", label: "Años de experiencia" },
        { value: "1,200+", label: "Clientes atendidos" },
        { value: "50", label: "Estados cubiertos" },
        { value: "100%", label: "Bilingüe ES/EN" },
      ],
    },
    testimonials: {
      overline: "Lo que dicen nuestros clientes",
      title: "Confianza que se construye un cliente a la vez",
      items: [
        {
          name: "Parentela Creaciones",
          role: "Pequeño negocio · Danbury, CT",
          text:
            "Los mejores 🔥 ¡Nuestros aliados en contabilidad! Siempre orientándonos y ayudándonos a mantener todo en orden. Qué importante es contar con profesionales que te acompañen durante todo el año.",
        },
        {
          name: "María González",
          role: "Salón de belleza · Bridgeport, CT",
          text:
            "Llevo cuatro años con Julio. Antes de él, cada abril me daba ansiedad. Ahora le mando mis papeles por WhatsApp y en una semana ya está todo listo. Me explica cada cosa en español, sin apuros.",
        },
        {
          name: "Carlos Reyes",
          role: "Contratista 1099 · Paterson, NJ",
          text:
            "Yo hacía mis taxes en TurboTax y siempre terminaba debiendo. El primer año con ellos me enseñaron qué puedo deducir trabajando por mi cuenta. Este año hasta me devolvieron algo. Llevo tres años con el mismo equipo.",
        },
        {
          name: "Lucía Paredes",
          role: "Diseñadora · Santiago, RD",
          text:
            "Me mudé a República Dominicana y pensé que ya no tenía que declarar en EE.UU. Julio me explicó lo del FEIE y el FBAR con paciencia. Hicimos todo por videollamada, muy fácil.",
        },
        {
          name: "Andrés Molina",
          role: "Restaurante dominicano · Bronx, NY",
          text:
            "Cuando abrí el restaurante no sabía ni por dónde empezar. Me ayudaron con la LLC, el EIN, y ahora llevan mi contabilidad mes a mes. Lo mejor es que cuando me llega una carta rara del IRS, les escribo y ellos la resuelven.",
        },
        {
          name: "Sofía Torres",
          role: "Asistente dental · Elizabeth, NJ",
          text:
            "Soy madre soltera y el año pasado me reclamaron créditos que yo ni sabía que existían. El reembolso me alcanzó para pagar la escuela de los niños. Súper agradecida con el equipo.",
        },
        {
          name: "Jorge Vega",
          role: "Desarrollador freelance · Queens, NY",
          text:
            "Lo que más me gusta es que no desaparecen después de abril. Les escribo en junio con una duda y me responden ese mismo día. Buenos precios y buen trato.",
        },
      ],
    },
    contact: {
      overline: "Hablemos",
      title: "Agenda tu consulta gratuita",
      subtitle:
        "Cuéntanos qué necesitas y te respondemos en menos de 24 horas hábiles. Sin compromiso.",
      form: {
        name: "Nombre completo",
        email: "Correo electrónico",
        phone: "Teléfono (opcional)",
        service: "Servicio de interés",
        service_placeholder: "Selecciona un servicio",
        message: "Cuéntanos tu situación",
        submit: "Enviar mensaje",
        sending: "Enviando…",
        success: "¡Gracias! Recibimos tu mensaje. Te contactaremos pronto.",
        error: "Hubo un error. Por favor intenta de nuevo o llámanos.",
      },
      info: {
        phone_label: "Teléfono",
        phone_value: "475-218-0489",
        whatsapp_label: "WhatsApp",
        whatsapp_value: "Chatea con nosotros",
        hours_label: "Horario",
        hours_value: "Lun – Sáb · 9am – 7pm",
      },
    },
    footer: {
      tagline: "Impuestos sin estrés. Negocios bien hechos.",
      rights: "Todos los derechos reservados.",
      links: "Enlaces",
      contact: "Contacto",
    },
    whatsapp_aria: "Chatear por WhatsApp",
  },
  en: {
    brand: "Rodríguez Tax Services",
    brand_tag: "Taxes · Bookkeeping · Business",
    nav: {
      home: "Home",
      services: "Services",
      about: "Experience",
      testimonials: "Testimonials",
      contact: "Contact",
      cta: "Book a consultation",
    },
    lang_toggle: "ES",
    hero: {
      overline: "Professional bilingual services",
      title: "Your taxes, your business,",
      title_accent: "handled with care.",
      subtitle:
        "Personal & business tax prep, bookkeeping, LLC formation and expat tax services. Clear, honest, bilingual advice (EN/ES).",
      cta_primary: "Book your consult",
      cta_secondary: "See services",
      stat_label: "Families & businesses served",
      stat_value: "+1,200",
      founder_byline: "Personally handled by Julio Rodríguez",
      founder_label: "Founder",
      founder_title: "Tax Advisor · Bilingual Specialist",
    },
    services: {
      overline: "What we do",
      title: "Services built around your life and your business",
      subtitle:
        "From a simple personal return to forming your LLC, we walk you through every step.",
      items: [
        {
          key: "personal",
          name: "Personal Taxes",
          desc: "We maximize your refund and make sure every credit you qualify for is included.",
          features: ["W-2 and 1099", "Child tax credit & EITC", "State and federal"],
        },
        {
          key: "business",
          name: "Business · Schedule C",
          desc: "For self-employed, contractors and small business owners. We maximize legitimate deductions.",
          features: ["LLC and sole proprietor", "Expense deductions", "Quarterly estimates"],
        },
        {
          key: "expats",
          name: "Expats",
          desc: "If you live abroad or have international income, we handle FBAR, FEIE and more.",
          features: ["Form 2555 (FEIE)", "FBAR / FinCEN", "Tax treaties"],
        },
        {
          key: "bookkeeping",
          name: "Bookkeeping",
          desc: "Keep your books current year-round to make better decisions and avoid surprises.",
          features: ["Monthly reconciliations", "P&L reports", "QuickBooks / Wave"],
        },
        {
          key: "formation",
          name: "Business Formation",
          desc: "We help you set up your LLC or Corp, get your EIN and start on the right foot.",
          features: ["LLC, S-Corp, C-Corp", "EIN & operating agreement", "Initial advisory"],
        },
      ],
      learn_more: "Learn more",
    },
    selector: {
      overline: "How can we help?",
      title: "Tell us your problem — we'll show you the fix",
      subtitle:
        "Pick the situation that best describes what you need and we'll show you exactly which service solves it.",
      problems: [
        {
          id: "p1",
          q: "I don't know how to file as self-employed or 1099 contractor",
          a: "We help you with Schedule C, legitimate deductions and estimated payments so the IRS doesn't surprise you.",
          link_label: "See Schedule C service",
          link_to: "/services#business",
        },
        {
          id: "p2",
          q: "I live outside the US and don't know if I should file",
          a: "If you're a citizen or resident, you most likely do. We handle FEIE, FBAR and all international forms.",
          link_label: "See Expats service",
          link_to: "/services#expats",
        },
        {
          id: "p3",
          q: "I want to start an LLC but don't know where to begin",
          a: "We guide you through everything: choosing the state, forming the entity, getting the EIN and opening a business bank account.",
          link_label: "Start my business",
          link_to: "/services#formation",
        },
        {
          id: "p4",
          q: "My books are a mess and I need to catch up",
          a: "Monthly or quarterly catch-up bookkeeping, bank reconciliations and reports you actually understand.",
          link_label: "See bookkeeping",
          link_to: "/services#bookkeeping",
        },
        {
          id: "p5",
          q: "I got a letter from the IRS and don't know what to do",
          a: "We review the notice with you, explain what they want and help you respond correctly.",
          link_label: "Talk to us",
          link_to: "/contact",
        },
        {
          id: "p6",
          q: "I want a bigger refund this year",
          a: "We review your situation, available credits and potential amendments to prior years.",
          link_label: "Book a review",
          link_to: "/contact",
        },
      ],
    },
    about: {
      overline: "About us",
      title: "Over a decade helping our community",
      caption_label: "Founder",
      caption_role: "Tax Advisor · Rodríguez Tax Services",
      p1: "Rodríguez Tax Services was built to give the Hispanic community and small business owners clear, honest and bilingual service. We know how hard it is to navigate the tax system in another language, so we simplify every step.",
      p2: "We work with families, freelancers, business owners and expats all across the US. Every client gets personal attention — never a line number.",
      stats: [
        { value: "12+", label: "Years of experience" },
        { value: "1,200+", label: "Clients served" },
        { value: "50", label: "States covered" },
        { value: "100%", label: "Bilingual EN/ES" },
      ],
    },
    testimonials: {
      overline: "What our clients say",
      title: "Trust earned one client at a time",
      items: [
        {
          name: "Parentela Creaciones",
          role: "Small business · Danbury, CT",
          text:
            "The best 🔥 Our accounting allies! Always guiding us and helping us keep everything in order. It's so important to have professionals who stick with you all year long.",
        },
        {
          name: "María González",
          role: "Hair salon owner · Bridgeport, CT",
          text:
            "I've been with Julio for four years. Before him, every April gave me anxiety. Now I just send my paperwork over WhatsApp and a week later everything is done. He explains every line in Spanish, no rush.",
        },
        {
          name: "Carlos Reyes",
          role: "1099 contractor · Paterson, NJ",
          text:
            "I used to file on TurboTax and always ended up owing. My first year with them I finally learned what I can deduct as a self-employed guy. This year I even got some back. Three years with the same team now.",
        },
        {
          name: "Lucía Paredes",
          role: "Designer · Santiago, DR",
          text:
            "I moved to the Dominican Republic and figured I didn't need to file in the US anymore. Julio patiently explained FEIE and FBAR to me. We did everything over video call — super easy.",
        },
        {
          name: "Andrés Molina",
          role: "Dominican restaurant owner · Bronx, NY",
          text:
            "When I opened the restaurant I didn't know where to start. They helped me with the LLC, the EIN, and now they do my books every month. Best part: when a weird IRS letter shows up, I message them and they handle it.",
        },
        {
          name: "Sofía Torres",
          role: "Dental assistant · Elizabeth, NJ",
          text:
            "I'm a single mom and last year they claimed credits for me I didn't even know existed. The refund covered my kids' school supplies. So grateful to the whole team.",
        },
        {
          name: "Jorge Vega",
          role: "Freelance developer · Queens, NY",
          text:
            "What I love most is that they don't disappear after April. I message them in June with a question and I get an answer the same day. Fair prices and great people.",
        },
      ],
    },
    contact: {
      overline: "Let's talk",
      title: "Book your free consultation",
      subtitle:
        "Tell us what you need and we'll get back to you within 24 business hours. No obligation.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        service: "Service of interest",
        service_placeholder: "Select a service",
        message: "Tell us your situation",
        submit: "Send message",
        sending: "Sending…",
        success: "Thanks! We got your message. We'll reach out shortly.",
        error: "Something went wrong. Please try again or give us a call.",
      },
      info: {
        phone_label: "Phone",
        phone_value: "475-218-0489",
        whatsapp_label: "WhatsApp",
        whatsapp_value: "Chat with us",
        hours_label: "Hours",
        hours_value: "Mon – Sat · 9am – 7pm",
      },
    },
    footer: {
      tagline: "Taxes without stress. Business done right.",
      rights: "All rights reserved.",
      links: "Links",
      contact: "Contact",
    },
    whatsapp_aria: "Chat on WhatsApp",
  },
};

export const WHATSAPP_LINK = "https://wa.me/14752180489";
export const PHONE_DISPLAY = "475-218-0489";
export const PHONE_LINK = "tel:+14752180489";
